import { TranslationJson } from './layout/LoanForm';

export const validateRegex = (value, regex, message) => {
  if (value && !regex.test(value)) {
    return message;
  }
};

export const validateFunc = (value, fn, message) => {
  if (value && !fn(value)) {
    return message;
  }
};

export const nameRe = /^[\p{Letter}]+(?:(\s|-)[\p{Letter}\p{Mark}]+)?$/u;

export const employeeStreetRe = /^([\p{Letter}\p{Mark}]+(?:( |-|(\. ))[\p{Letter}\p{Mark}]+)?)*$/u;

export const occupationRe = /^([\p{Letter}\p{Mark}]+(?:( )[\p{Letter}\p{Mark}]+)?)*$/u;

export const zipValidator = (t: TranslationJson, value: string) =>
  validateRegex(value, /^[0-9]{2}-[0-9]{3}$/, t.common.valueError);

export const isValidPeselControlSum = (value: string) => {
  if (value.length !== 11) {
    return false;
  }

  const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  const controlNumber = parseInt(value.substring(10, 11));
  let sum = 0;
  let control = 10;
  weights.filter((weight, index) => (sum += parseInt(value.substring(index, index + 1)) * weight));
  sum %= 10;

  if (sum === 0) {
    control = 0;
  }

  return control - sum === controlNumber;
};
